/**
 * Created by augustocorvalan on 7/17/15.
 */
'use strict';

var _ = require('underscore');
var Backbone = require('dibs-backbone');
var SoaModel = require('bunsen/models/SoaModel');
var AnchorList = require('bunsen/models/AnchorList');
var AnchorMember = require('bunsen/models/AnchorMember');

var PromoAnchorList = module.exports = AnchorList.extend();

_.extend(PromoAnchorList, {
    createAnchorList: function (sourceType, ids, note) {
        return new PromoAnchorList({ members: AnchorMember.createAnchorMembers(sourceType, ids, note) });
    }
});

_.extend(PromoAnchorList.prototype, {
    relations: SoaModel.createRelations([
        {
            key:          'members',
            type:         Backbone.Many,
            relatedModel: AnchorMember
        }
    ]),
    getIds: function () {
        var members = this.get('members') || [];
        return members.map(function (member) {
            return member.get('anchor.sourceId');
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/PromotionAnchorList.js
// module id = 170
// module chunks = 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54